import { useCallback, useState } from 'react';

const ONBOARDING_STORAGE_KEY = 'buildmate_onboarding_v1';

type SeenMap = Record<string, boolean>;

function readSeenMap(): SeenMap {
  try {
    const raw = localStorage.getItem(ONBOARDING_STORAGE_KEY);
    return raw ? (JSON.parse(raw) as SeenMap) : {};
  } catch {
    return {};
  }
}

function writeSeenMap(map: SeenMap) {
  try {
    localStorage.setItem(ONBOARDING_STORAGE_KEY, JSON.stringify(map));
  } catch {
    // Ignore quota / private-mode failures
  }
}

/**
 * Bir tur/onboarding parçasının daha önce görülüp görülmediğini localStorage'da tutar.
 * PanelLayout.tsx'teki THEME_STORAGE_KEY pattern'iyle aynı try/catch guard yaklaşımı.
 */
export function useOnboarding(tourId: string) {
  const [hasSeen, setHasSeen] = useState<boolean>(() => readSeenMap()[tourId] === true);

  const markSeen = useCallback(() => {
    const map = readSeenMap();
    map[tourId] = true;
    writeSeenMap(map);
    setHasSeen(true);
  }, [tourId]);

  const reset = useCallback(() => {
    const map = readSeenMap();
    delete map[tourId];
    writeSeenMap(map);
    setHasSeen(false);
  }, [tourId]);

  return { hasSeen, markSeen, reset };
}
